<div *ngIf="user()" class="container-fluid">
    <h1>Albert v4.0 Home</h1>
</div>

<div *ngIf="!user()" class="home-p my-container">
        <span class="login-bt cursor">Albert v4.0</span>
        <span class="center-img"><img (click)="login()" src="../../assets/img/logo.svg" alt="logo albert 4.0" class="img-fluid img-c cursor"></span>
        <span (click)="login()" class="login-bt cursor">Login</span>
</div>